export const getExternalUrl = (value: string) =>
	/^https?:\/\//i.test(value) ? value : `https://${value}`;
